import React from 'react';
import ReactDOM from 'react-dom/client';
import SortingVisualizer from './SortingVisualizer/SortingVisualizer';
import 'bootstrap/dist/css/bootstrap.css';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <SortingVisualizer />
);

